<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-16 10:30:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-29 15:58:32
 * @FilePath:
 * @Description: 扫码点单后的订单提交页面
-->
<template>
  <div class="place_order_con">
    <div class="f-bt join_member_con" v-if="!isMember">
      <div>成为会员可享优惠</div>
      <div class="join_right_con" @click="handleToRegisterPage">
        立即加入 <i class="iconfont icon-xiangyou" />
      </div>
    </div>
    <van-row type="flex" justify="space-between" gutter="20">
      <van-col span="12">
        <van-cell title="桌号" :value="deskCode.code" />
      </van-col>
      <van-col span="12">
        <van-cell title="人数">
          <template #extra>
            <p @click="handleToPeopleNum">
              {{ orderPeople }}人
              <van-icon name="arrow-down" color="#969799" />
            </p>
          </template>
        </van-cell>
      </van-col>
    </van-row>
    <div class="placeOrderList">
      <van-row
        class="title_con"
        type="flex"
        justify="space-between"
        align="center"
      >
        <h3>点餐信息</h3>
        <!-- <van-col span="12"> -->
        <van-tabs
          line-width="24px"
          line-height="2px"
          color="#333"
          title-inactive-color="#999"
          title-active-color="#333"
          v-model="tabActive"
        >
          <van-tab
            name="type"
            title="按类型"
            title-class="card_tabs_con"
          ></van-tab>
          <!-- <van-tab
            name="people"
            title="按人"
            title-class="card_tabs_con"
          ></van-tab> -->
        </van-tabs>
        <!-- </van-col> -->
      </van-row>
      <!-- <goodListCard
        :carGoodsList="commodityInformation"
        :allPrice="allPrice"
        :allNum="allNum"
      ></goodListCard> -->
      <goodListCard
        :carGoodsList="commodityInformation"
        :isChangeNum="true"
        :showFoodType="true"
        :allPrice="allPrice"
        :allNum="allNum"
      >
        <template v-slot:default="slotDataObj">
          <van-stepper
            :value="slotDataObj.goodsItem.num"
            theme="round"
            button-size="22"
            min="0"
            disable-input
            async-change
            :show-minus="slotDataObj.goodsItem.num > 0"
            :show-input="slotDataObj.goodsItem.num > 0"
            :disable-plus="
              slotDataObj.goodsItem.IsSellOut &&
              slotDataObj.goodsItem.SellOutNumber != null &&
              slotDataObj.goodsItem.num + 1 >
                slotDataObj.goodsItem.SellOutNumber
            "
            @plus="handleSetGoodsAndPrice(slotDataObj.goodsItem, 'add')"
            @minus="handleSetGoodsAndPrice(slotDataObj.goodsItem, 'minus')"
          />
        </template>
        <template v-slot:mealName="slotDataObj">
          <div class="meal_desc_con">
            <p>{{ slotDataObj.goodsItem.mealNameStr }}</p>
          </div>
        </template>
      </goodListCard>
    </div>
    <div class="placeOrderList">
      <van-row class="title_con" type="flex" align="center">
        <h3>支付方式</h3>
      </van-row>
      <PayRadioCom
        ref="payMethodCom"
        @handleResetCardInfo="handleResetCardInfo"
      ></PayRadioCom>
    </div>
    <div class="placeOrderList">
      <van-row class="title_con" type="flex" align="center">
        <h3>订单备注</h3>
      </van-row>

      <van-field
        v-model="orderRemark"
        rows="4"
        autosize
        label=""
        type="textarea"
        maxlength="100"
        show-word-limit
        placeholder="其他需求，可以在此处给商家留言哦"
      />
      <ul class="quick-remark">
        <li
          v-for="(item, index) in quickRemarkList"
          :key="index"
          :class="selectedRemarks.includes(item) ? 'active' : ''"
          @click="onSelectRemark(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="footer">
      <div class="money">
        <span>￥{{ allPrice }}</span>
      </div>
      <div class="c-flex">
        <div class="m-r-10">
          <van-button color="#333" round plain @click="handleBackPoint"
            >继续加菜</van-button
          >
        </div>

        <van-button
          color="#333"
          round
          :disabled="allNum <= 0"
          @click="handleSubmitOrder"
          :loading="isSubmitLoading"
          loading-text="提交中..."
          >提交订单</van-button
        >
      </div>

      <!-- <p class="dark-btn" @click="placeOrder"
      v-if="keyBindMode !== 'ManualInputByWaiter' || handCode">{{ wechatPointPayMode === 'CyBillWithPad' ? '呼叫服务员' : '提交订单' }}</p> -->
    </div>
  </div>
</template>

<script>
import {
  Notify,
  Col,
  Row,
  Cell,
  Field,
  Popup,
  Area,
  Checkbox,
  Dialog,
} from "vant";
import { areaList } from "@vant/area-data";
import {
  handleLocalStorage,
  handleScanCode,
  handleSessionStorage,
} from "@/utils";
import { submitFoodOrder } from "@/api/foodOrder";
import { getScanTakeNumberInfo } from "@/api/scan";
import { getUserCardInfo } from "@/api/member";
import { mapActions, mapState, mapGetters } from "vuex";
import goodListCard from "@/components/goodsListCard";
import PayRadioCom from "@/components/PayComps";
import { handleSendMessage } from "@/utils/websorket";
import { EventBus } from "@/utils/eventbus";
import { setToken } from "@/utils/auth";

export default {
  name: "NewPlaceOrder",
  props: {},
  data() {
    return {
      isMember: true,
      areaList,
      showAreaSelect: false,
      cardCodeInfo: { id: null, code: "" },
      tabActive: "type",
      vpnCode: "",
      parlorcode: "",
      wechatPointPayMode: "",
      isSubmitLoading: false,
      isHandBill: false,
      goodsList: [],
      diningInfo: {
        seatCode: "",
        repastNum: "",
        position: "",
      },
      commodityInformation: {},
      wechatPointTableQRCode: "",
      orderRemark: "",
      keyBindMode: "ScanQRcode",
      quickRemarkList: [], // 快捷备注备选项
      selectedRemarks: [], // 已选快捷备注
      isGroupConfig: false,
    };
  },
  components: {
    goodListCard,
    PayRadioCom,
  },
  computed: {
    ...mapState({
      userFoodsListObj: (rootState) => rootState.shopCart.carGoodsList, //购物车中物品列表
      orderPeople: (rootState) => rootState.order.orderPeople, //人数
    }),
    ...mapGetters("shopCart", {
      allNum: "allNum",
      allPrice: "allPrice",
    }),
    // deskCode() {
    //   console.log(99999);
    //   const preDeskCode = handleSessionStorage.get("deskCode");
    //   return (
    //     preDeskCode || { code: "", depart: "", checkinId: "", cardCode: "" }
    //   );
    // },
    payMethodType() {
      return this.$refs.payMethodCom.payType;
    },
  },
  watch: {
    tabActive(val) {
      this.commodityInformation =
        val == "type" ? this.typeFoodsListObj : this.userFoodsListObj;
    },
  },
  created() {
    const dinidnRoomInfo = handleSessionStorage.get("diningRoomInfo");
    if (dinidnRoomInfo && dinidnRoomInfo.Remark) {
      this.quickRemarkList = dinidnRoomInfo.Remark.split(",");
    }

    const preDeskCode = handleSessionStorage.get("deskCode");
    this.deskCode = preDeskCode || {
      code: "",
      depart: "",
      checkinId: "",
      cardCode: "",
    };
    const vpnStorage = handleSessionStorage.get("vpnInfo");
    this.vpnId = vpnStorage.id;
    this.vpnInfo = vpnStorage;
    this.isGroupConfig = vpnStorage.EnableTeamOrder;
    //查询是否微会员
    this.handleInitMemberInfo();
    this.teamId = handleSessionStorage.get("teamId");
    this.isSureVpn = handleSessionStorage.get("isSureVpn"); //此时确认唯一门店,true时才可多人点餐
    if (this.isGroupConfig && this.isSureVpn) {
      EventBus.$on("getGroupGoodsList", (data) => {
        // 接收服务端发送来的消息
        console.log("提交订单页的初始列表收到了-------------", data);

        // 初始化购物车商品
        this.$store.commit("shopCart/initCardList", data);
        this.handleInitShowFoodsListObj();
        // this.commodityInformation = goodsArr;
      });
      EventBus.$on("getMessage", (data) => {
        // 接收服务端发送来的消息
        console.log("订单提交页成功收到了-------------", data);

        if (data.Quantity > 0) {
          //某商品增加了
          data = { ...data, num: data.Quantity };
          this.receivemessageSuccess(
            data,
            data.Quantity,
            "add",
            "isOtherPoint"
          );
        } else {
          data = { ...data, num: -data.Quantity };
          this.receivemessageSuccess(
            data,
            -data.Quantity,
            "minus",
            "isOtherPoint"
          );
        }
      });
      handleSendMessage("SendGoodsList", {
        TeamId: this.teamId,
        duration: vpnStorage.OrderTeamDuration,
      });
      // setTimeout(() => {
      //   console.log("推入了");
      //   this.receivemessageSuccess(
      //     {
      //       Id: 299793400,
      //       IsMultiSpecific: false,
      //       GoodsName: "aa",
      //       Price: 234,
      //       GoodsCatalogId: 299792744,
      //       num: 1,
      //       GoodsCatalog: "午餐",
      //     },
      //     // { Id: 299793400 },

      //     1,
      //     "add"
      //   );
      // }, 5000);
      // setTimeout(() => {
      //   console.log("添加了多规格的");
      //   this.receivemessageSuccess(
      //     {
      //       Id: 299793405,
      //       IsMultiSpecific: true,
      //       GoodsName: "丸子汤",
      //       Price: 22,
      //       GoodsCatalogId: 299792735,
      //       num: 1,
      //       GoodsCatalog: "营养小吃",
      //       SpecificId: 1110,
      //       Name: "大份",
      //     },
      //     // { Id: 299793400 },

      //     1,
      //     "add"
      //   );
      // }, 8000);
      // setTimeout(() => {
      //   console.log("去除了");
      //   this.receivemessageSuccess(
      //     {
      //       Id: 299793400,
      //       IsMultiSpecific: false,
      //       GoodsName: "aa",
      //       Price: 234,
      //       GoodsCatalogId: 299792744,
      //       num: 1,
      //       GoodsCatalog: "午餐",
      //     },
      //     // { Id: 299793400 },

      //     1,
      //     "minus"
      //   );
      // }, 13000);
    } else {
      this.handleInitShowFoodsListObj();
    }
    // if (!this.$store.state.cardInfo.id) {
    // this.handleGetNumberInfo();
    // } else {
    //   this.cardCodeInfo = this.$store.state.cardInfo;
    // }
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    EventBus.$off("getGroupGoodsList");
    EventBus.$off("getMessage");
    next();
  },
  methods: {
    ...mapActions("shopCart", {
      ADD_COUNT: "ADD_COUNT",
      MINUS_COUNT: "MINUS_COUNT",
      CLEAR_LIST: "CLEAR_LIST",
    }),
    handleInitShowFoodsListObj() {
      const typeListObj = {};
      for (let userId in this.userFoodsListObj) {
        const nowList = this.userFoodsListObj[userId].list;
        nowList.forEach((item) => {
          if (!typeListObj[item.GoodsCatalogId]) {
            typeListObj[item.GoodsCatalogId] = {
              name: item.GoodsCatalog,
              list: [item],
              smallPrice: this.$calc.multiply(item.num, item.Price),
              smallNum: item.num,
            };
          } else {
            typeListObj[item.GoodsCatalogId].list.push(item);
            // typeListObj[item.GoodsCatalogId].smallPrice +=
            //   item.num * item.Price;
            typeListObj[item.GoodsCatalogId].smallPrice = this.$calc.add(
              typeListObj[item.GoodsCatalogId].smallPrice,
              this.$calc.multiply(item.num, item.Price)
            );
            typeListObj[item.GoodsCatalogId].smallNum += item.num;
          }
        });
      }
      this.typeFoodsListObj = typeListObj;
      this.commodityInformation = typeListObj;
    },
    handleToPeopleNum() {
      this.$router.push({
        name: "InputPeopleNum",
        query: { fromPage: "NewPlaceOrder" },
      });
    },
    receivemessageSuccess(nowItem, tempNum, type, flag) {
      if (flag == "isOtherPoint") {
        let tasteObj = {};
        if (nowItem.Taste) {
          const tasteArr = nowItem.Taste.split(",");
          tasteArr.forEach((tItem) => {
            tasteObj[tItem] = tItem;
          });
        }
        nowItem = Object.assign({}, ...nowItem, {
          Name: item.Specification,
          MethodName: item.DoWay || "",
          TasteNameObj: tasteObj,
        });
      }
      if (type == "add") {
        // 修改购物车中商品列表
        this.ADD_COUNT({
          userInfo: { userId: 1, name: "我" },
          item: nowItem,
          stepNum: tempNum,
        });
      } else {
        // 修改购物车中商品列表
        this.MINUS_COUNT({
          userInfo: { userId: 1, name: "我" },
          item: nowItem,
          stepNum: tempNum,
        });
      }
      this.handleInitShowFoodsListObj();
    },
    // 点击添加或减少商品
    handleSetGoodsAndPrice(item, type) {
      event.stopPropagation(); // 阻止事件冒泡
      console.log("提交订单也");
      console.log(item);
      if (type == "add") {
        // const stepNum=item.num?item.StepNum:item.MinNum
        const stepNum = item.num ? 1 : item.MinBuyCount ? item.MinBuyCount : 1;
        if (
          item.RestrictionCount &&
          item.num + stepNum > item.RestrictionCount
        ) {
          return this.$toast("添加数量超过餐品限点数量，无法添加哦");
        }
        this.receivemessageSuccess(item, stepNum, "add");
        if (this.isGroupConfig && this.isSureVpn) {
          const param = {
            // ...item,
            TeamId: this.teamId,
            Quantity: stepNum,
            TableCode: this.deskCode.code,
            VpnId: this.vpnInfo.id,
            duration: this.vpnInfo.OrderTeamDuration,
            GoodsCatalog: item.GoodsCatalog,
            GoodsCatalogId: item.GoodsCatalogId,
            GoodsName: item.GoodsName,
            Id: item.Id,
            IsMultiSpecific: item.IsMultiSpecific || false,
            PicUrl: item.PicUrl,
            Price: item.Price,
            MinBuyCount: item.MinBuyCount,
          };
          if (item.IsMultiSpecific) {
            param.SpecificId = item.SpecificId;
            param.Specification = item.Name;
          }
          if (item.MethodName) {
            param.DoWay = item.MethodName;
          }
          if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
            param.Taste = Object.keys(item.TasteNameObj).sort().join(",");
          }

          handleSendMessage("SendChangeGoods", param);
        }
      } else {
        // 减少数量时 若所剩余数量少于每次需要减少的步数，则只减少当前苏剩余数量
        const stepNum =
          !item.MinBuyCount || item.num - item.MinBuyCount > 0
            ? 1
            : item.MinBuyCount;

        // item.num - 1 < 0 ? item.num : 1;
        this.receivemessageSuccess(item, stepNum, "minus");
        if (this.isGroupConfig && this.isSureVpn) {
          const param = {
            // ...item,
            TeamId: this.teamId,
            Quantity: -stepNum,
            TableCode: this.deskCode.code,
            VpnId: this.vpnInfo.id,
            duration: this.vpnInfo.OrderTeamDuration,
            GoodsCatalog: item.GoodsCatalog,
            GoodsCatalogId: item.GoodsCatalogId,
            GoodsName: item.GoodsName,
            Id: item.Id,
            IsMultiSpecific: item.IsMultiSpecific || false,
            PicUrl: item.PicUrl,
            Price: item.Price,
            MinBuyCount: item.MinBuyCount,
          };
          if (item.IsMultiSpecific) {
            param.SpecificId = item.SpecificId;
            param.Specification = item.Name;
          }
          if (item.MethodName) {
            param.DoWay = item.MethodName;
          }
          if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
            param.Taste = Object.keys(item.TasteNameObj).sort().join(",");
          }
          handleSendMessage("SendChangeGoods", param);
        }
      }
    },

    // handleGetNumberInfo() {
    //   getScanTakeNumberInfo().then((res) => {
    //     this.cardCodeInfo = {
    //       id: res.KeyId,
    //       code: res.TableCode,
    //     };
    //     this.checkinId = res.CheckinId;
    //     this.$store.commit("set_cardinfo", this.cardCodeInfo);
    //   });
    // },
    sweepCode(codeType) {
      // coedeType: 码类型（0：手牌二维码，1： 桌台二维码）
      var _this = this;
      let NeedResultType = 1;
      // 扫手牌二维码，二维码是手动输入手牌号生成模式，
      if (!codeType && this.wechatPointTableQRCode === "MMode") {
        NeedResultType = 0; //执行微信返回的结果=>页面跳转到手牌绑定界面
        handleLocalStorage.set("isReturnPlaceOrder", "true");
        this.cacheBindInfo();
      }
      // 调起微信扫码，并执行成功函数
      handleScanCode({ needResult: NeedResultType }, this.handleScanSuccess);
    },
    handleScanSuccess(res) {
      // if (res) {
      //         var result = res.resultStr; // 微信扫一扫返回二维码内容
      //         console.log(`11111***** result ***** 538行 ~/jinguiProject/wxweb-vue-main/src/pages/SelfHelp/PlaceOrder.vue  17:02:45`);
      //         console.log(result);
      //         console.log(`22222***** codeType ***** 540行 ~/jinguiProject/wxweb-vue-main/src/pages/SelfHelp/PlaceOrder.vue  17:03:03`);
      //         console.log(codeType);
      //         console.log(`33333***** _this.keyBindMode ***** 542行 ~/jinguiProject/wxweb-vue-main/src/pages/SelfHelp/PlaceOrder.vue  17:03:15`);
      //         console.log(_this.keyBindMode);
      //         if (codeType && _this.keyBindMode === 'TableCodeBindHandler') {
      //           // 扫桌台二维码，手牌绑定模式是手牌绑定器（二维码中既包含加密的桌台号、门店编号、手牌号，获取加密参数，调用接口进行手牌绑定，绑定成功把手牌号、桌台号回填到页面上）
      //           const encryptionParams = result.split('?p=')[1];
      //           postKeybindhander(encryptionParams)
      //             .then(res => {
      //               if (res.wechatpointurl) {
      //                 _this.$vux.toast.text('手牌绑定中请稍后', 'middle')
      //                 const v = _this.getQueryVariable(res.wechatpointurl, 'v') // 餐台二维码携带的vpnCode
      //                 const d = _this.getQueryVariable(res.wechatpointurl, 'd') // 餐台二维码携带的部门名称
      //                 const c = _this.getQueryVariable(res.wechatpointurl, 'c') // 餐台二维码携带的餐台号
      //                 if (v) {
      //                   handleLocalStorage.set('VpnCode', v);
      //                 }
      //                 handleLocalStorage.set('departmentName', d);
      //                 temporaryStorage.set('diningInfo', { seatCode: c, repastNum: _this.peopleNum, position: _this.diningInfo.position })
      //                 setTimeout(() => {
      //                   location.reload()
      //                 }, 1000)
      //               } else {
      //                 _this.$vux.toast.text('keybindhander接口未返回wechatpointurl', 'middle')
      //               }
      //             })
      //             .catch(err => {
      //               _this.$vux.toast.text(err, 'middle')
      //             })
      //           return
      //         }
      //         // 以下逻辑为非手牌绑定器模式的扫桌台号、手牌号
      //         var param = '';
      //         var path = result.split('?')[0];
      //         var curHost = window.location.host;
      //         if (!_this.vpnCode) {
      //           _this.vpnCode = handleLocalStorage.get('VpnCode');
      //         }
      //         if (result.includes('/SelfHelp/Micropoint')) { // 兼容新版餐台二维码：http://{0}.goldensoftcn.com/page1/index.html#/SelfHelp/Micropoint?s={1}&d={2}&v={3}&c={4}
      //           if (result.includes('?s=')) {
      //             let v = _this.getQueryVariable(result, 'v');// 餐台二维码携带的vpnCode
      //             const s = _this.getQueryVariable(result, 's');// 餐台二维码携带的餐厅类型Id
      //             if (_this.getQueryVariable(result, 't') === '1') { // 缩减后的餐台二维码链接vpnCode门店编号需要进行转义
      //               const transferRes = await _this.codeTransfer(v, s)
      //               v = transferRes.VpnCode
      //             }
      //             const d = _this.getQueryVariable(result, 'd');// 餐台二维码携带的部门名称
      //             const c = _this.getQueryVariable(result, 'c');// 餐台二维码携带的餐台号
      //             if (path.indexOf(curHost) > -1 && v.toUpperCase() === _this.vpnCode.toUpperCase()) {
      //               handleLocalStorage.set('departmentName', d)
      //               console.log("%c d ", "background-image:color:transparent;color:blue;font-size:2em");
      //               console.log(d);
      //               _this.parlorcode = d;
      //               _this.diningInfo.seatCode = c
      //             } else {
      //               _this.$vux.toast.text('餐台二维码与当前门店不匹配', 'middle');
      //             }
      //           } else {
      //             _this.$vux.toast.text('餐台二维码未携带餐台信息', 'middle');
      //           }
      //         } else {
      //           console.log(`55555***** result ***** 603行 ~/jinguiProject/wxweb-vue-main/src/pages/SelfHelp/PlaceOrder.vue  17:03:50`);
      //           console.log(result);
      //           if (result.indexOf('=') > -1) {
      //             param = result.split('=')[1];
      //           } else {
      //             param = result.split('?')[1];
      //           }
      //           if (param === null) {
      //             _this.$vux.toast.text('参数为空', 'middle');
      //           } else {
      //             console.log(`66666***** path ***** 613行 ~/jinguiProject/wxweb-vue-main/src/pages/SelfHelp/PlaceOrder.vue  17:04:08`);
      //             console.log(path);
      //             var paramArr = '';
      //             if (result.indexOf('=') > -1) {
      //               paramArr = param.split('@');
      //             } else {
      //               paramArr = param.split('/');
      //             }
      //             if (path.indexOf(curHost) > -1 && paramArr[0].toUpperCase() === _this.vpnCode.toUpperCase() && codeType) {
      //               // 扫码绑定桌台
      //               handleLocalStorage.set('departmentName', paramArr[2]);
      //               _this.diningInfo.seatCode = paramArr[1];
      //             } else if (path.indexOf(curHost) > -1 && paramArr[1].toUpperCase() === _this.vpnCode.toUpperCase() && !codeType) {
      //               // 扫码绑定手牌
      //               _this.machineId = paramArr[0];
      //               gettingBindingHandNumberInformation(_this.machineId).then((res) => {
      //                 if (res) {
      //                   const bindingUuid = res.BindingUuid;
      //                   bindingHandNumber('?machineid=' + bindingUuid).then(function(res) {
      //                     _this.isNeedBindHand = false;
      //                     _this.handCode = res.TableCode
      //                     _this.parlorcode = res.Parlorcode
      //                   }).catch((err) => {
      //                     _this.$vux.toast.text(err, 'middle');
      //                   });
      //                 }
      //               }).catch((err) => {
      //                 _this.$vux.toast.text(err, 'middle');
      //               });
      //             } else {
      //               _this.$vux.toast.text('二维码无效', 'middle');
      //             }
      //           }
      //         }
      //       }
    },
    // 跳转页面前缓存桌台、位置信息
    cacheBindInfo() {
      // handleTimeLocalStorage.set('diningInfo', this.diningInfo, 1000 * 60 * 30);
      // if (this.wechatPointTableQRCode === 'MMode' || this.wechatPointPayMode === 'CyBillWithPad') {
      //   // 微点单二维码生成模式为员工手动输入 || 微点单结账流程为先点单后开牌（Pad服务员绑手牌模式）缓存用餐信息30分钟，提交订单后清除缓存
      //   handleTimeLocalStorage.set('diningInfo', this.diningInfo, 1000 * 60 * 30);
      // } else {
      //   // 其他模式下，采用临时缓存用餐信息，退出程序后缓存自动清除
      //   temporaryStorage.set('diningInfo', this.diningInfo);
      // }
    },
    // 选择备注
    onSelectRemark(remark) {
      const i = this.selectedRemarks.findIndex((item) => item === remark);
      if (i > -1) {
        this.selectedRemarks.splice(i, 1);
      } else {
        this.selectedRemarks.push(remark);
      }
    },
    myShippingAddress(item) {
      // let addressId = item.Id;
      // if (!addressId) {
      //   addressId = 'Null';
      // }
      // this.$router.push({
      //   name: 'MyShippingAddress',
      //   params: {
      //     AddressId: addressId
      //   },
      //   query: {
      //     fromPage: 'SelfHelpPlaceOrder'
      //   }
      // });
    },
    // 校验&组织提交订单请求参数
    // placeOrder(){
    //
    // 弹出是否需要打包
    // this.dabaoHandle()
    // },
    // dabaoHandle(){
    //   Dialog.confirm({
    //     title: '是否打包',
    //     message: '请确认您是否打包菜品',
    //   })
    //     .then(() => {
    //       // on confirm
    //       this.confirmDialog()
    //       this.handleSubmitOrder();
    //     })
    //     .catch(() => {
    //       // on cancel
    //       this.handleSubmitOrder();
    //     });
    // },
    // 确认打包
    // confirmDialog() {

    // const copySelectRemarks = this.$pub.deepClone(this.selectedRemarks);
    // copySelectRemarks.push('打包')
    // this.requestData.GuestRemark = copySelectRemarks.join(',');
    //   this.handleSubmitOrder();
    // },
    // 绑定手牌后重新设置当前页面的deskCode值
    handleResetCardInfo() {
      console.log("55555");
      const preDeskCode = handleSessionStorage.get("deskCode");
      this.deskCode = preDeskCode;
    },
    handleBackPoint() {
      this.$router.go(-1);
    },
    handleSubmitOrder() {
      if (this.payMethodType == 1 && !this.deskCode.cardCode) {
        Notify({ type: "warning", message: "暂未绑定手牌，请先绑定手牌！" });
        return;
      }
      Dialog.confirm({
        title: "提示",
        message: "是否确认下单当前菜品？",
        cancelButtonText: "再看看",
      })
        .then(() => {
          // on confirm
          this.submitOrder();
        })
        .catch(() => {
          // on cancel
          // this.isSubmit = true;
        });
    },
    submitOrder() {
      console.log("提交");
      //   const _this = this;
      this.isSubmitLoading = true;
      let foodsList = [];
      for (let userId in this.commodityInformation) {
        const nowList = this.commodityInformation[userId].list;
        nowList.forEach((item) => {
          let RemarkStr = item.Remark || "";
          RemarkStr = item.CustomRemark
            ? RemarkStr + " " + item.CustomRemark
            : RemarkStr;
          let newItem = {
            ProductId: item.Id,
            ProductName: item.GoodsName,
            ProductType: item.GoodsCatalog,
            Quantity: item.num,
            Remark: RemarkStr,
            GoodsServiceId: item.IsServiceId,
          };
          if (item.IsMultiSpecific) {
            newItem.SpecificId = item.SpecificId;
            newItem.Specification = item.Name;
          }
          if (item.MethodName) {
            newItem.DoWay = item.MethodName;
          }
          if (item.TasteNameObj && Object.keys(item.TasteNameObj).length > 0) {
            newItem.Taste = Object.keys(item.TasteNameObj).sort().join(",");
          }
          if (item.IsServiceId == 6) {
            let subArr = [];
            for (var key in item.selectGoodsObj) {
              const sItem = item.selectGoodsObj[key];
              sItem.forEach((gItem) => {
                subArr.push({
                  GoodsId: gItem.GoodsId,
                  GoodsName: gItem.GoodsName,
                  GoodsServiceId: 6,
                  NumberCount: gItem.num,
                  PackageMealGroupId: key,
                });
              });
            }
            newItem.SubMealDTOs = subArr;
          }
          foodsList.push(newItem);
        });
      }

      const requestData = {
        TeamId: this.isGroupConfig && this.isSureVpn ? this.teamId : null,
        VpnId: this.vpnId,
        PayType: this.payMethodType,
        KeyCode: this.deskCode.cardCode,
        CheckinId: this.deskCode.checkinId,
        TableCode: this.deskCode.code,
        // DepartId: this.deskCode.depart,
        PersonNum: this.orderPeople,
        TotalAmount: this.allPrice,
        Remark:
          (this.orderRemark ? this.orderRemark + "；" : "") +
          this.selectedRemarks.join(),
        Items: foodsList,
        CancelOrderId: this.preOrderId,
      };
      console.log(requestData);
      submitFoodOrder(requestData)
        .then((res) => {
          this.preOrderId = null;
          this.isSubmitLoading = false;
          if (res.UnPaidOrderId) {
            //当前还有未支付订单
            Dialog.confirm({
              title: "提示",
              message:
                "您有未支付的自助点单订单，您可以选择取消未支付的订单，或者继续支付上一个订单",
              cancelButtonText: "取消订单",
              confirmButtonText: "继续支付",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  name: "RecordsConsumption",
                });
              })
              .catch(() => {
                // on cancel
                this.preOrderId = res.UnPaidOrderId;
                this.submitOrder();
              });
            return;
          }
          this.CLEAR_LIST();
          if (this.payMethodType == 2) {
            //在线支付
            this.$router.replace({
              name: "PayList",
              query: { id: res.OrderId, fromPage: "food" },
            });
          } else {
            this.$router.replace("PlaceOrderSuccess");
          }
        })
        .catch(() => {
          this.isSubmitLoading = false;
        });
      //     if (res.errmsg) {
      //       this.isSubmit = true;
      //       this.$vux.toast.text(res.errmsg, 'middle')
      //       return
      //     }

      //     if (res) {
      //       // 提交订单成功回调
      //       if (this.wechatPointTableQRCode === 'MMode' || this.wechatPointPayMode === 'CyBillWithPad') {
      //         // 微点单二维码生成模式为员工手动输入 || 微点单结账流程为先点单后开牌（Pad服务员绑手牌模式）缓存用餐信息30分钟，提交订单后清除缓存
      //         handleLocalStorage.remove('diningInfo', this.diningInfo);
      //       }

      //       if (res.LastOrderId && res.LstConsumeWaternum.length > 0 && !this.isHandBill && this.wechatPointPayMode !== 'CyBill') {
      //         // 非挂账模式下微点单只允许有一个未支付订单
      //         this.$vux.confirm.show({
      //           title: '提示',
      //           content: '您有未支付的自助点单订单，您可以选择取消未支付的订单，或者继续支付上一个订单',
      //           cancelText: '取消订单',
      //           confirmText: '继续支付',
      //           onConfirm(sm) {
      //             _this.$router.push({
      //               name: 'PaymentDetial',
      //               params: {
      //                 OrderId: res.LastOrderId
      //               }
      //             });
      //           },
      //           onCancel(sm) {
      //             deletePurchaseRecordCancelsPayment({
      //               lstConsumeWaternum: res.LstConsumeWaternum,
      //               OrderId: res.LastOrderId
      //             }).then(res => {
      //               _this.$vux.toast.text('取消成功,您可以继续提交当前订单', 'middle');
      //               _this.isSubmit = true;
      //             }).catch((err) => {
      //               _this.isSubmit = true;
      //               _this.$vux.toast.text(err, 'middle');
      //             });
      //           }
      //         });
      //       } else {
      //         this.$vux.toast.text('提交成功', 'middle');
      //         if (this.urlType !== 102088) {
      //           handleLocalStorage.set('MachineId', res.DingdingCode);
      //           handleLocalStorage.set('lstConsumeWaternum', res.LstConsumeWaternum.toString());
      //           handleLocalStorage.set('departmentName', res.DepartmentName);
      //           // 清空购物车
      //           handleLocalStorage.remove('goodsDetial');
      //         }
      //         if (this.isHandBill || this.wechatPointPayMode === 'CyBill' || this.wechatPointPayMode === 'CyBillWithPad') {
      //           // 手牌挂账 || 餐台挂账模式 || 微信呼叫服务员PAD开单模式
      //           let bindCode = ''
      //           if (this.isHandBill) {
      //             // 手牌挂账模式查询消费明细用手牌号
      //             bindCode = this.handCode
      //           } else if (this.wechatPointPayMode === 'CyBill' || this.wechatPointPayMode === 'CyBillWithPad') {
      //             // 餐台挂账模式 || 微信呼叫服务员PAD开单模式查询消费明细用餐台号
      //             bindCode = this.diningInfo.seatCode
      //           }
      //           this.$router.push({
      //             name: 'PlaceOrderSuccess',
      //             params: {
      //               TableCode: bindCode
      //             },
      //             query: {
      //               modeType: this.wechatPointPayMode
      //             }
      //           });
      //         } else {
      //           setTimeout(() => {
      //             this.$router.push({
      //               name: 'PaymentDetial',
      //               params: {
      //                 OrderId: res.OrderId
      //               }
      //             });
      //           }, 500);
      //         }
      //       }
      //     } else { // 手动录单模式，提交订单成功返回的是空字符串
      //       if (this.wechatPointPayMode === 'HandPointAdd') {
      //         this.$vux.toast.text('提交成功', 'middle');
      //         setTimeout(() => {
      //           // 清空购物车
      //           handleLocalStorage.remove('goodsDetial');
      //           // 页面跳转点单历史记录页面
      //           this.$router.push({
      //             name: 'RecordsConsumption'
      //           });
      //         }, 500)
      //       }
      //     }
      //   }).catch((err) => {
      //     this.isSubmit = true;
      //     this.$vux.toast.text(err, 'middle');
      //   });
    },
    handleInitMemberInfo() {
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if (res.Code) {
          this.isMember = false;
          return;
        }
        if (res.Token) {
          setToken(res.Token);
        }

        this.isMember = true;
      });
    },
    handleToRegisterPage() {
      this.$router.push({
        name: "ValidMember",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.place_order_con {
  min-height: 100vh;
  padding: 30px 30px 100px;
  box-sizing: border-box;
  .join_member_con {
    padding: 23px 20px;
    background: linear-gradient(90deg, #e6c590 0%, #caa264 100%);
    border-radius: 8px;
    color: #333;
    font-size: 28px;
    margin-bottom: 20px;
    .join_right_con {
      color: #573500;
      i {
        font-size: 28px;
      }
    }
  }
  .placeOrderList {
    .title_con {
      ::v-deep {
        &.van-tabs--line {
          .van-tabs__wrap {
            height: 25px !important;
            .van-tabs__nav {
              background-color: transparent !important;
            }
          }
        }
        .van-tab {
          padding: 0 4px;
          font-size: 14px;
          line-height: 20px;
          cursor: pointer;
          flex: none !important;
          margin-right: 20px;
        }
        .card_tabs_con {
          font-size: 24px;
        }
      }
    }
    h3 {
      // height: 80px;
      padding-left: 20px;
      // background: #f3f5f9;
      // line-height: 80px;
      color: #000;
      font-size: 30px;
    }
  }
  .quick-remark {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 20px;
    padding: 10px;
    box-sizing: border-box;
    > li {
      flex: none;
      padding: 12px 28px;
      margin: 0 20px 10px 0;
      font-size: 24px;
      color: #666;
      border-radius: 30px;
      border: 1px solid rgba(5, 5, 5, 0.1);
      &.active {
        color: #ff5c10;
        border: 1px solid #ff5c10;
      }
    }
  }
  .order-remark {
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
  }
}
.group-detail {
  display: inline;
  padding: 4px;
  border: 1px solid #70d8d9;
  color: #70d8d9;
  font-size: 16px;
}
.name {
  line-height: 100%;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  // height: 100px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 10px 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  .money {
    height: 100%;
    line-height: 100px;
    margin-right: 20px;
    flex-shrink: 0;
    span {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
